import React, { useState, useEffect } from 'react';

import { SearchButton, EnableBadge, DisableBadge } from '../../Res/BaseButton';
import moment from 'moment';
import { SingleSelect, SingleText } from '../../Res/BaseInput';
import { DatePickerInput } from 'rc-datepicker';
import Swal from 'sweetalert2';

export function PerformanceSearch({ action, ssd, sed, reserveCount, onBoardCount, cancelCount,  resignCount}) {

    const [mReserveCount, setReserveCount]= useState(0)
    const [mOnBoardCount, setoOnBoardCount]= useState(0)
    const [mCancelCount, setCancelCount]= useState(0)
    const [mResignCount, setResignCount]= useState(0)

    const [interval, setInterval] = useState("1")
    const [startDate, setStartDate] = useState("")
    const [endDate, setEndDate] = useState("")
    const [startEnd, setStartEnd] = useState("")

    const [startError, setStartError] = useState(false)
    const [endError, setEndError] = useState(false)

    const startString = '起始日期'
    const endString = '結束日期'

    useEffect(() => {
        // console.log("interval")
        switch (interval) {
            case "1":
                getDay()
                break;
            case "2":
                getWeek()
                break;
            case "3":
                getMonth()
                break;
            default:
                getDay()
                break;
        }
    }, [interval])

    useEffect(()=>{
        if(startDate !== "" && endDate !== "")
        switch (interval) {
            case "1":
            case "2":
            case "3":
                toSerch()
                break;
            default:
                break;
        }
    },[startDate, endDate])

    useEffect(()=>{
        if(reserveCount !== undefined && reserveCount !== mReserveCount){
            setReserveCount(reserveCount)
        }
    },[reserveCount])
    useEffect(()=>{
        if(onBoardCount !== undefined && onBoardCount !== mOnBoardCount){
            setoOnBoardCount(onBoardCount)
        }
    },[onBoardCount])
    useEffect(()=>{
        if(cancelCount !== undefined && cancelCount !== mCancelCount){
            setCancelCount(cancelCount)
        }
    },[cancelCount])
    useEffect(()=>{
        if(resignCount !== undefined && resignCount !== mResignCount){
            setResignCount(resignCount)
        }
    },[resignCount])

    function getDay() {
        const start = moment().format('YYYY/MM/DD'); //本週一
        const end = moment().format('YYYY/MM/DD'); //本週日
        setStartDate(start)
        setEndDate(end)
        setStartEnd(start + "~" + end)
        ssd(start)
        sed(end)
        setStartError(false)
        setEndError(false)
    }

    function getWeek() {
        const start = moment().weekday(1).format('YYYY/MM/DD'); //本週一
        const end = moment().weekday(7).format('YYYY/MM/DD'); //本週日
        setStartDate(start)
        setEndDate(end)
        setStartEnd(start + "~" + end)
        ssd(start)
        sed(end)
        setStartError(false)
        setEndError(false)
    }

    function getMonth() {
        const start = moment().startOf('month').format('YYYY/MM/DD');
        const end = moment().endOf('month').format('YYYY/MM/DD');
        setStartDate(start)
        setEndDate(end)
        setStartEnd(start + "~" + end)
        ssd(start)
        sed(end)
        setStartError(false)
        setEndError(false)
    }

    const onChangeStartDate = (jsDate, dateString) => {
        //console.log(jsDate)
        //console.log(dateString)
        if (dateString === "Invalid date") {
            setStartError(true)
        } else {
            setStartError(false)
            setStartDate(dateString)
            ssd(dateString)
        }
    }

    const onChangeEndDate = (jsDate, dateString) => {
        //console.log(jsDate)
        //console.log(dateString)
        if (dateString === "Invalid date") {
            setEndError(true)
        } else {
            setEndError(false)
            setEndDate(dateString)
            sed(dateString)
        }
    }
    
    function toSerch(){
        var atError = []
        if (startError) {
            atError.push(startString)
        }
        if (endError) {
            atError.push(endString)
        }
        if (atError.length > 0) {
            Swal.fire({
                type: 'error',
                title: '提醒',
                text: atError.join(',') + ' 格式有誤, 請確認月日為2位數',
            })
            return
        }
        action()
    }

   return(
        <>
            <div className="row">
                <SingleSelect title={"工作狀態"}
                    val={interval}
                    attr={[
                        { "val": "1", "name": "本日" },
                        { "val": "2", "name": "本週" },
                        { "val": "3", "name": "本月" },
                        { "val": "4", "name": "以起迄日期計算" }
                    ]}
                    action={setInterval}
                    size={3}
                />
                {interval !== "4" ?
                    <SingleText title={"計算區間"} val={startEnd} /> :
                    <>
                        <div className="col-md-3">
                            <p>請選擇計算起始日期</p>
                            <DatePickerInput
                                displayFormat='YYYY/MM/DD'
                                returnFormat='YYYY/MM/DD'
                                onChange={onChangeStartDate}
                                value={startDate}
                                className='my-react-component'
                            />
                        </div>
                        <div className="col-md-3">
                            <p>請選擇計算結束日期</p>
                            <DatePickerInput
                                displayFormat='YYYY/MM/DD'
                                returnFormat='YYYY/MM/DD'
                                onChange={onChangeEndDate}
                                value={endDate}
                                className='my-react-component'
                            />
                        </div>
                        <div className="col-md-3">
                            <p>&nbsp;</p>
                            <SearchButton name={"搜尋"} action={toSerch} />
                        </div>
                    </>
                }
            </div>
            <div className="hr-line-dashed"></div>
            <div className="row">
                <EnableBadge count={mReserveCount} text={"預定"} size={3} />
                <EnableBadge count={mOnBoardCount} text={"報到"} size={3} />
                <DisableBadge count={mCancelCount} text={"未報到"} size={3} />
                <DisableBadge count={mResignCount} text={"離職"} size={3} />
            </div>
        </>
    )
}